<div class="flex flex-col gap-4 p-5">
	<h3>Reasignar PAS</h3>
	<p class="text-gray-600 text-sm">Seleccioná el nuevo PAS para este cliente.</p>

	<app-search-users
		label="Buscar PAS"
		userRoles="AGENT"
		(userSelected)="setAgent($event)" />

	@if (selectedAgent(); as agent) {
		<p>PAS seleccionado: <strong>{{ getAgentName(agent) }}</strong></p>
	}

	<div class="flex gap-3">
		<activar-button text="Cancelar" fill="out" expand="full" [disabled]="submitting()" (click)="cancel()" />
		<activar-button
			text="Confirmar"
			fill="solid"
			color="primary"
			expand="full"
			[disabled]="!canConfirm()"
			[loading]="submitting()"
			loadingText="Reasignando..."
			(click)="confirm()" />
	</div>
</div>
